// components/RoleBasedDashboard.jsx
import React from 'react';
import TruckRegistration from '../Pages/truck-registration/TruckRegistration';
import { useAuth } from '../auth/AuthProvider';


const RolesBasedTruckRegistration = () => {
    // Mocked user role; in real application, get it from authentication context or a similar state.
    const { screens } = useAuth();
    const userRole = screens?.roleName; // Example: 'admin', 'buyer', 'seller'

    const renderTruckRegistration= (role) => {
        console.log("role", role.toLocaleLowerCase())
        switch (role.toLowerCase()) {
            case 'admin':
                return <TruckRegistration />;
            case 'truck_registration':
                return <TruckRegistration />;
            default:
                return <div>Unauthorized</div>;
        }
    };

    return renderTruckRegistration(userRole)
};

export default RolesBasedTruckRegistration;
